import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { sortBy } from 'lodash';
import { debounceTime, Subject } from 'rxjs';
import { UserPermission } from 'src/app/enums/enums';
import { PermissionService } from 'src/app/services/app/permission-access-service/permissionBased.service';
import { AppointmentTypeService } from 'src/app/services/core/appointment-type/appointment-type.service';
import { CompanyService } from 'src/app/services/core/company/company.service';
import { FundingSourceService } from 'src/app/services/core/funding-source/funding-source.service';
import { LosService } from 'src/app/services/core/levelOfService/los.service';
import { MemberService } from 'src/app/services/core/member/member.service';
import { SpaceTypeService } from 'src/app/services/core/spaceTypes/space-type.service';
import { CsvService } from 'src/app/services/csv-service/csv.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
@UntilDestroy()

@Component({
  selector: 'app-member-list',
  templateUrl: './member-list.component.html',
  styleUrls: ['./member-list.component.css']
})
export class MemberListComponent implements OnInit {
  search:any
  members:any;
  currentPage: any = 1;
  totalPages: any = 0;
  totalResults: any = 0;
  numberOfRecords: any = NUMBER_OF_RECORDS;
  isItemsPerPageOpen = false;
  pageSizeOptions: number[] = [100,200,300,400,500];
  status = true
  memberDetail:any;
  memberData:any;
  userPermission=UserPermission
  private readonly searchSubject = new Subject<string | undefined>();
  preAppointmentTypes:any = {};
  preCompanies:any = {};
  preFundingSource:any = {};
  preSpaceType:any = {};
  preLevelOfService:any = {};
  editMemberObj: any;
  mergeModalObj: any;
  isDropdownOpen = false;
  selectedMembers: any = [];
  selectedFundingSource = '';
  selectedMemberType = '';
  fundingSources:any;
 
  constructor(
  private memberService: MemberService,
  public permissionService: PermissionService,
  private csvService: CsvService,
  private companyService: CompanyService,
  private spaceTypeService: SpaceTypeService,
  private levelOfService: LosService,
  private appointmentType: AppointmentTypeService,
  private fundingSource: FundingSourceService
  
  ){}
  ngOnInit() {
    this.getAllMembers(this.currentPage)
    this.listenSearch();
    this.getAllCompanies();
    this.getAppointmentTypes();
    this.getSpaceType();
    this.getLevelOfService();
    this.getFundingSources();
  }

  getAllMembers(page: number) {
  let queryParams: any = {
    limit: this.numberOfRecords,
    page,
    isActive: this.status,
    sortBy: 'firstName:asc'
  };
    if (this.selectedFundingSource) {
    queryParams.fundingsource = this.selectedFundingSource;
  }
  if (this.selectedMemberType) {
    queryParams.memberType = this.selectedMemberType;
  }
  this.selectedMembers = [];
  if (this.search) {
    queryParams['search'] = this.search;
    this.memberService.searchData(queryParams)
      .pipe(untilDestroyed(this))
      .subscribe((data: any) => {
        if (data && data.results) {
          this.members = data.results.map((member: any) => ({
            ...member,
            isSelected: false
          }))
          this.totalPages = data.totalPages;
          this.totalResults = data.totalResults;
        }
      });
  } else {
    this.memberService.getMembers(queryParams)
      .pipe(untilDestroyed(this))
      .subscribe((data: any) => {
        if (data && data.results) {
          this.members = data.results.map((member: any) => ({
            ...member,
            isSelected: false
          }));
          this.totalPages = data.totalPages;
          this.totalResults = data.totalResults;
        }
      });
  }
}


  onPageChange(page: number) {
    this.currentPage = page;
    this.getAllMembers(this.currentPage);
  }

  toggleItemsPerPageDropdown(event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this.isItemsPerPageOpen = !this.isItemsPerPageOpen;
  }

  closeItemsPerPageDropdown() {
    this.isItemsPerPageOpen = false;
  }

  onLimitChange(limit: number) {
    this.isItemsPerPageOpen = false;
    if (this.numberOfRecords === limit) {
      return;
    }
    this.numberOfRecords = limit;
    this.currentPage = 1;
    this.getAllMembers(this.currentPage);
  }


  onSelectStatus(event: any): void {
   this.status = event.target.value === 'true';
   this.selectedMembers = [];
    this.getAllMembers(this.currentPage = 1);
  }

  memberTrips(data:any){
    this.memberDetail = data;
  }

  opendetailModal(member:any){
    this.memberData = member
  }

    onSearch(query: any) {
      this.searchSubject.next(query);
    }
  
  listenSearch() {
    this.searchSubject
      .pipe(debounceTime(500), untilDestroyed(this))
      .subscribe((search) => {
        this.currentPage = 1;
        this.members = [];
        this.selectedMembers = [];
        this.getAllMembers(this.currentPage);
      });
  }

  downloadMemberCSV() {
    const exportMembers = this.selectedMembers && this.selectedMembers.length ? this.selectedMembers : this.members;
    this.csvService.generateMemberCSV(
      exportMembers,
      this.preFundingSource,
      this.preSpaceType,
      this.preLevelOfService,
      this.preAppointmentTypes,
      this.preCompanies
    );
  }

  onFundingSourceChange() {
    this.getAllMembers(this.currentPage);
  }

  onMemberTypeChange() {
    this.currentPage = 1;
    this.getAllMembers(this.currentPage);
  }

  getFundingSources() {
  this.fundingSource
    .getPicker({ isActive: true, limit: 9999 })
    .pipe(untilDestroyed(this))
    .subscribe((data: any) => {
      if (data?.results?.length) {
        this.fundingSources = data.results.sort((a: any, b: any) =>
          (a.title || '').toLowerCase().localeCompare((b.title || '').toLowerCase())
        );

        this.preFundingSource = this.fundingSources.reduce(
          (obj: any, item: any) => ((obj[item.id || item._id] = item), obj),
          {}
        );
      } else {
        this.fundingSources = [];
        this.preFundingSource = {};
      }
    });
}


  getAppointmentTypes() {
    this.appointmentType.getPicker({ isActive: true, limit: 999 }).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.preAppointmentTypes = data.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
      }
    })
  }

  getAllCompanies() {
    let queryParams = {
      limit: 9999,
      isActive: true,
      isApproved: true
    }
    this.companyService.getPickerCompanies(queryParams)
      .subscribe((data: any) => {
        if (data && data.results) {
          this.preCompanies = data.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }
      })
  }


  getLevelOfService() {
    const queryparams = {
      limit: 9999,
      isActive: true
    }
    this.levelOfService.getPicker(queryparams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results) {
          this.preLevelOfService = data.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }
      })
  }
  getSpaceType() {
    const queryparams = {
      limit: 9999,
      isActive: true
    }
    this.spaceTypeService.getPicker(queryparams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results) {
          this.preSpaceType = data.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }
      })
  }


  getFundingSource() {
    this.fundingSource.getPicker({ isActive: true, limit: 9999 }).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results) {
        this.preFundingSource = data.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
      }
    })
  }

  openMemberEditModal(member: any) {
    this.editMemberObj = member;
  }


  onSaveMember(evt: any) {
    if (evt) {
      const idx = this.members.findIndex((member: any) => member.id === evt.id);
      if (this.status === evt.isActive) {
        this.members[idx] = {...evt};
      } else {
        this.members.splice(idx, 1);
      }
    }
    this.editMemberObj = null;
  }


  openMergeModal() {
    this.mergeModalObj = JSON.parse(JSON.stringify(this.selectedMembers));
  }

  onCloseMergeModal(secondaries: any) {
    this.mergeModalObj = false;
    if (secondaries && secondaries.length) {
      this.members = this.members.filter((member: any) => !secondaries.includes(member.id));
      this.members.forEach((member: any) => member.isSelected = false);
      this.selectedMembers = [];
    }
  }

  toggleDropdown(event: MouseEvent) {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  closeFilterDropDown(evt:any) {
    this.isDropdownOpen = false
  }

  onSelectAllMembers(event: any) {
    const checked = event.target.checked;
    this.members.forEach((member: any) => member.isSelected = checked);
    this.selectedMembers = checked ? [...this.members] : [];
    this.isDropdownOpen = checked;
  }

  onSelectMember(member: any) {
    const index = this.selectedMembers.findIndex((m: any) => m.id === member.id);
    if (index > -1) {
      this.selectedMembers.splice(index, 1);
    } else {
      this.selectedMembers.push(member);
    }
    if (this.selectedMembers.length) {
      this.isDropdownOpen = true;
    } else {
      this.isDropdownOpen = false;
    }
  }

}
